#import '../fragments/marketing-automation-fragment.graphql'

mutation UpdateMoneyPageAutomation($input: UrlAutomationUpdateInput!) {
    maUrlAutomationUpdate(input: $input) {
        automation {
            ...MarketingAutomationFragment
        }
    }
}
